module.exports = __webpack_public_path__ + "static/img/02_pro.351ab78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/02_pro.jpg
// module id = ljgy
// module chunks = 0